import { DatePickerControl } from '../../../engineClient/components/formControls/standard';
import { HpInputControlProps } from '../../../engineClient/types';
import { HpClaimsQuestionSetPageProps } from '../../questionSetForm/questionSetPageTypes';
import { resolveTokensInQuestionText } from './customControlUtilities';

export interface DatePickerWithDynamicQuestionTextCustomControlProps extends HpInputControlProps {
  pageProps: HpClaimsQuestionSetPageProps;
}

export function DatePickerWithDynamicQuestionTextCustomControl(
  props: DatePickerWithDynamicQuestionTextCustomControlProps
): JSX.Element {
  const { answers, pageProps, questionText } = props;
  const { productId, questions } = pageProps;

  const questionTextWithResolvedTokens = resolveTokensInQuestionText({
    questionText,
    answers,
    questions,
    productId
  });

  return <DatePickerControl {...props} questionText={questionTextWithResolvedTokens} />;
}
